import React, { FC, memo } from 'react';
import { ActionItem } from './ActionItem/ActionItem';
import type { ActionSectionProps } from './ActionSection.types';

export const ActionSection: FC<ActionSectionProps> = memo<ActionSectionProps>(({ section }) => (
  <ul data-hook="action-section-wrapper">
    {section.props.items.map((item) => (
      <li key={item.systemId}>
        <ActionItem item={item} section={section} />
      </li>
    ))}
  </ul>
));
